import { connect } from 'react-redux';
import NearbyStationsList from './NearbyStationsList';
import { fetchFuels } from '../../actions/fuels';
import { fetchNearbyStationsById } from '../../actions/nearby';
import getErrorMessage from '../../../lib/utils/getErrorMessage';

function mapStateToProps({ nearby, stationInfo, fuels }, ownProps) {
  const nearbyStationIds = nearby.stationsById[ownProps.stationId];

  const stations = nearbyStationIds?.length && nearbyStationIds.map(sid => (
    {
      ...stationInfo.stationsById[sid],
      displayFuel: (fuels.fuelsByStationId && fuels.fuelsByStationId[sid]) || {},
    }
  ));

  return {
    isFetching: nearby.isFetching,
    nearbyStationIds,
    stations,
    error: getErrorMessage(nearby.error, 'Error loading nearby stations'),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchFuels: stationIds => dispatch(fetchFuels(stationIds)),
    fetchNearbyStationsById: stationId => dispatch(fetchNearbyStationsById(stationId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NearbyStationsList);
